module.exports = [
  'RESTService',
  (RESTService) ->
    RESTService.setFullResponse(true).service('admin/settings')
]
